import type { JSX } from "react";
import RenderMark from "../../../shared/components/RenderMark";
import type { IDoc } from "./Report";

interface IProps {
    printing?: boolean;
    docList: IDoc[];
}

function NowWhat({ printing, docList }: IProps): JSX.Element {
    return printing ? (
        <RenderMark
            content={docList.find((doc) => doc.id === "player.team-scan.report-now-what-print").content}
            unsafe
        />
    ) : (
        <RenderMark content={docList.find((doc) => doc.id === "player.team-scan.report-now-what").content} unsafe />
    );
}

export default NowWhat;
